import { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useModals } from "@mantine/modals";
import { Stepper } from "@mantine/core";
import { Modal } from "@mantine/core";
import { ReactComponent as Logo } from "../../../../../assets/logo.svg";
import MobileLogo from "../../../../../assets/logo-new-img.png";
import { ReactComponent as Back } from "../../../../../assets/modalBackIcon.svg";
import { ReactComponent as Close } from "../../../../../assets/modalCloseIcon.svg";
import { ReactComponent as CheckIcon } from "../../../../../assets/Check.svg";
import "./eligibilityModal.css";
import CustomButton from "../../../../../components/CustomButton";
import SelectClaimType from "./steppers/SelectClaimType";
import FlightDetails from "./steppers/FlightDetails";
import FlightCheck from "./steppers/FlightCheck";
import EligibilityResult from "./steppers/EligibilityResult";
import EmailAndAgreement from "./steppers/EmailAndAgreement";
import ClaimQuestions from "./steppers/ClaimQuestions";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import base_url from "../../../../../api/bootapi";

const CheckEligibilityModal = ({
  open,
  close,
  selectedArrival,
  selectedDeparture,
  setSelectedArrival,
  setSelectedDeparture,
  claimReason,
}) => {
  const modals = useModals();

  // const handleClose = () => {
  //   modals.openConfirmModal({
  //     title: "Confirm Close",
  //     children: "Are you sure you want to exit?",
  //     labels: { confirm: "Yes", cancel: "No" },
  //     onConfirm: () => {
  //       // Clear all localStorage keys used by child components
  //       localStorage.removeItem("claimType");
  //       localStorage.removeItem("flightDetailsData");
  //       localStorage.removeItem("flightCheckData");
  //       localStorage.removeItem("claimQuestionsData");
  //       localStorage.removeItem("emailAgreementData");

  //       close(false);
  //     },
  //   });
  // };

  const navigate = useNavigate();
  const [active, setActive] = useState(1);
  const [stepone, setStepone] = useState(false);
  const [steptwo, setSteptwo] = useState(false);
  const [stepthree, setStepthree] = useState(false);
  const [stepfour, setStepfour] = useState(false);
  const [stepfive, setStepfive] = useState(false);
  const [stepsix, setStepsix] = useState(false);
  const [backdropopen, setbackdropopen] = useState(false);

  // State to store form data from all steps
  const [formData, setFormData] = useState({
    claimType: "",
    flightDetails: {},
    flightCheck: {},
    claimQuestions: {},
    emailAndAgreement: {},
  });


  console.log(formData)
  const clearLocalStorage = () => {
    const keysToRemove = [
      "claimType",
      "flightDetailsData",
      "flightCheckData",
      "claimQuestionsData",
      "emailAgreementData",
      "eligibilityStep",
    ];

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  };

  const handleClose = () => {
    clearLocalStorage();
    setFormData({
    claimType: "",
    flightDetails: {},
    flightCheck: {},
    claimQuestions: {},
    emailAndAgreement: {},
    })
    setActive(1);
    close(false);
  };

  const handleNext = () => {
    if (active === 1) {
      const form = document.getElementById("claim-type-form");
      if (form) form.requestSubmit();
    } else if (active === 2) {
      const form = document.getElementById("flight-details-form");
      if (form) form.requestSubmit();
    } else if (active === 3) {
      const form = document.getElementById("flight-check-form");
      if (form) form.requestSubmit();
    } else if (active === 4) {
      const form = document.getElementById("claim-questions-form");
      if (form) form.requestSubmit();
    } else if (active === 5) {
      const form = document.getElementById("email-agreement-form");
      if (form) form.requestSubmit();
      // submitFormData() is now called inside handleFormSubmit when active === 5
    } else if (active === 6) {
      redirectToFullClaim();
    } else {
      setActive((current) => current + 1);
    }
  };

  const redirectToFullClaim = async () => {
    navigate("/file-claim");
  };

  const [getemail, setemail] = useState();
  const [geteligible, seteligible] = useState();
  const [getCompensationamount, setCompensationamount] = useState();
  const [getCompensationmessage, setCompensationmessage] = useState();
  const [completedStep, setCompletedStep] = useState(
    localStorage.getItem("eligibilityStep") || 1
  );

  const setCurrentStep = (active) => {
    const step = active + 1;

    if (step > completedStep) {
      setCompletedStep(step);
      localStorage.setItem("eligibilityStep", step);
    }
  };

  const handleFormSubmit = (data) => {
    setemail(data.email);
    // Update form data state based on the current step
    if (active === 1) {
      setFormData((prev) => ({ ...prev, claimType: data }));
      setStepone(true);
    } else if (active === 2) {
      setFormData((prev) => ({ ...prev, flightDetails: data }));
      setSteptwo(true);
    } else if (active === 3) {
      setFormData((prev) => ({ ...prev, flightCheck: data }));
      setStepthree(true);
    } else if (active === 4) {
      setFormData((prev) => ({ ...prev, claimQuestions: data }));
      setStepfour(true);
    } else if (active === 5) {
      // Use a callback to ensure the state is updated correctly
      setFormData((prev) => ({ ...prev, emailAndAgreement: data }));
      setStepfive(true);
      submitFormData(data.email); // Call submitFormData with the email value
    }
    setActive((current) => current + 1);
    setCurrentStep(active);
  };

  const formatDOB = (dateOfBirth) => {
    const parts = dateOfBirth?.split?.("-");

    if (parts?.length !== 3) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    }

    const [month, day, year] = parts;
    return year?.length === 4
      ? `${year}-${month}-${day}`
      : `${day}-${month}-${year}`;
  };

  // Function to submit all form data to the API
  const submitFormData = async (email) => {
    setbackdropopen(true);
    let newdata = {
      claim_type: formData?.claimType?.claimType,
      // compensation_rule: 1,
      // regulation: "EU261",
      // user_id: 1,
      flight_date: formatDOB(formData?.flightDetails?.flight_date),
      departed_from: formData?.flightDetails?.departureAirport?.value,
      arrival_airport: formData?.flightDetails?.arrivalAirport?.value,
      airline_name: formData?.flightDetails?.airlineName?.value,
      flight_number: formData?.flightDetails?.flightNumber,
      num_of_passangers: Number(formData?.flightDetails?.numberOfPassengers),
      direct_flight: formData?.flightCheck?.isDirectFlight === "true",
      connecting_flight_affected: formData?.flightCheck?.isEffected === "true",
      more_about_issue: formData?.claimQuestions?.issueDescription,
      additional_details: formData?.claimQuestions?.additionalDeails,

      email: email,
      agree_to_tandc: true,
    };

    // Add fields based on claim_type
    switch (formData?.claimType?.claimType) {
      case "delayed":
        newdata = {
          ...newdata,
          delay_minutes: Number(formData?.claimQuestions?.delay),
          airline_provide_reson:
            formData?.claimQuestions?.reasonFordelay === "true",
          claim_details: formData?.claimQuestions?.issueDescription,
        };
        break;

      case "cancelled":
        newdata = {
          ...newdata,
          notification_of_cancellation:
            formData?.claimQuestions?.cancel === "true" || formData?.claimQuestions?.cancel === "14 days before departure",
          airline_proved_flight:
            formData?.claimQuestions?.reasonForcancel === "true",
          claim_details: formData?.claimQuestions?.issueDescription,
        };
        break;

      case "denied_boarding":
        newdata = {
          ...newdata,
          give_up_seat: formData?.claimQuestions?.overbook === "true",
          airline_proved_flight:
            formData?.claimQuestions?.reasonForoverbook === "true",
        };
        break;

      case "lost/damaged":
        newdata = {
          ...newdata,
          baggage_issue: formData?.claimQuestions?.damage,
          baggage_delay: formData?.claimQuestions?.reasonFordamage,
          item_cost: Number(formData?.claimQuestions?.item_cost),
        };
        break;

      case "other":
        newdata = {
          ...newdata,
          claim_type: "lost/damaged",
          item_cost: Number(formData?.claimQuestions?.item_cost),
        };
        break;

      default:
        // Handle other claim types or default case
        break;
    }
    try {
      const response = await axios.post(
        `${base_url.api1}/tourapp/check-eligibility`,
        newdata
      );
      console.log(
        "API Response:",
        response.data.compensation_amount_per_passenger
      );
      setCompensationamount(response.data.compensation_amount_per_passenger);
      setCompensationmessage(response.data.message);
      // Handle the API response (e.g., show success message or navigate to the next step)
      clearLocalStorage();
      setCompletedStep(null);
      setbackdropopen(false);
      seteligible(true);
    } catch (error) {
      seteligible(false);
      console.error("API Errorssss:", error.response.data.eligible);
      // Handle the error (e.g., show an error message)
      setbackdropopen(false);
    }
  };

  // Determine the button text based on the current step
  const getButtonText = () => {
    if (active === 5) {
      return "Check My Eligibility"; // Button text for the 5th step
    } else if (active === 6) {
      return "Continue to Full Claim"; // Button text for the 6th step
    } else {
      return "Next"; // Default button text for other steps
    }
  };

  return (
    <Modal
      opened={open}
      onClose={() => close(false)}
      fullScreen
      withCloseButton={false}
      padding={0}
      transitionProps={{ transition: "slide-up" }}
    >
      <div className="modal-wrapper">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropopen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <div>
          <div className="modal-toolbar">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <Back
                  onClick={() => {
                    if (active > 1) {
                      setActive((current) => current - 1);
                    }
                  }}
                  style={{ cursor: "pointer" }}
                />
                <span className="stepper-count">Step {active}/6</span>
              </div>
              <Link to={"/"} onClick={handleClose}>
                <Logo className="desktop-wrapper" />
                <img src={MobileLogo} alt="logo" className="mobile-wrapper" />
              </Link>
              <Close onClick={handleClose} />
            </div>
            <div style={{ marginTop: "20px" }} className="stepper-progress-bar">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#314064",
                    fontWeight: 500,
                  }}
                >
                  {active === 1
                    ? "Select claim type"
                    : active === 2
                    ? "Flight details"
                    : active === 3
                    ? "Connecting flight check"
                    : active === 4
                    ? "Claim-specific questions"
                    : active === 5
                    ? "Enter email & agree to terms"
                    : active === 6
                    ? "Eligibility results"
                    : "Fly claim"}
                </span>
                <span
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#314064",
                    fontWeight: 700,
                  }}
                >
                  Step {active}/6
                </span>
              </div>
              <div
                style={{
                  height: "4px",
                  borderRadius: "2px",
                  overflow: "hidden",
                  backgroundColor: "#E6F6FF",
                }}
              >
                <div
                  style={{
                    width: `${active * 17}%`,
                    height: "4px",
                    borderRadius: "2px",
                    backgroundColor: "#314064",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-main-wrapper">
          <div className="modal-main-left">
            <h4>Your claim progress</h4>
            <div>
              <Stepper
                active={active}
                onStepClick={(step) => {
                  // Only allow going to completed steps (steps before current active)
                  if (step < completedStep) {
                    setActive(step + 1);
                  }
                }}
                icon={false}
                orientation="vertical"
                mt={"xl"}
                completedIcon={<CheckIcon />}
                styles={{
                  stepCompletedIcon: {
                    background: "#314064",
                    borderRadius: "50%",
                  },
                  stepLabel: {
                    paddingTop: "15px",
                    color: "#7B8287",
                    cursor: (step) =>
                      step < active - 1 ? "pointer" : "default",
                  },
                  stepDescription: {
                    display: "none",
                  },
                  stepIcon: {
                    background: "#E6F6FF",
                    border: 0,
                  },
                  separator: {
                    borderColor: "#314064",
                  },
                }}
              >
                <Stepper.Step label="Select claim type" />
                <Stepper.Step label="Flight details" />
                <Stepper.Step label="Connecting flight check" />
                <Stepper.Step label="Claim-specific questions" />
                <Stepper.Step label="Enter email & agree to terms" />
                <Stepper.Step label="Eligibility results" />
              </Stepper>
            </div>
          </div>
          <div className="modal-main-right">
            {active === 1 && (
              <SelectClaimType
                setStepone={setStepone}
                onSubmit={handleFormSubmit}
                claimReason={claimReason}
              />
            )}
            {active === 2 && (
              <FlightDetails
                setSteptwo={setSteptwo}
                onSubmit={handleFormSubmit}
                selectedArrival={selectedArrival}
                selectedDeparture={selectedDeparture}
                setSelectedArrival={setSelectedArrival}
                setSelectedDeparture={setSelectedDeparture}
              />
            )}
            {active === 3 && (
              <FlightCheck
                setStepthree={setStepthree}
                onSubmit={handleFormSubmit}
              />
            )}
            {active === 4 && (
              <ClaimQuestions
                setStepfour={setStepfour}
                onSubmit={handleFormSubmit}
                claimType={formData.claimType.claimType}
              />
            )}
            {active === 5 && (
              <EmailAndAgreement
                setStepfive={setStepfive}
                onSubmit={handleFormSubmit}
              />
            )}
            {active === 6 && (
              <EligibilityResult
                setStepsix={setStepsix}
                geteligible={geteligible}
                getCompensationamount={getCompensationamount}
                getCompensationmessage={getCompensationmessage}
              />
            )}

            <div
              style={{ marginTop: "40px" }}
              className="mobile-claim-status-btn-wrapper"
            >
              {active > 1 && active !== 6 && (
                <CustomButton
                  btnText={"Back"}
                  type="secondary"
                  onClick={() => setActive((current) => current - 1)}
                />
              )}

              <CustomButton
                btnText={getButtonText()} // Set button text dynamically
                type={
                  active === 1
                    ? stepone
                      ? "primary"
                      : "disable"
                    : active === 2
                    ? steptwo
                      ? "primary"
                      : "disable"
                    : active === 3
                    ? stepthree
                      ? "primary"
                      : "disable"
                    : active === 4
                    ? stepfour
                      ? "primary"
                      : "disable"
                    : active === 5
                    ? stepfive
                      ? "primary"
                      : "disable"
                    : "primary"
                }
                onClick={handleNext}
                style={{ float: "right" }}
                disabled={
                  active === 1
                    ? !stepone
                    : active === 2
                    ? !steptwo
                    : active === 3
                    ? !stepthree
                    : active === 4
                    ? !stepfour
                    : active === 5
                    ? !stepfive
                    : false
                }
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CheckEligibilityModal;
